import styled from "styled-components";
import { screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";

export const Wrapper = styled.div`
  max-width: 400px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    max-width: 100%;
  }
`;

export const Title = styled(typography.SecondarySmall)``;

export const ItemWrapper = styled.div`
  animation-duration: 600ms;
  animation-fill-mode: forwards;
  animation-name: ${props => (props.isRemoved ? "itemDisappears" : "none")};
  margin: 17px 0 0;

  @keyframes itemDisappears {
    0% {
      opacity: 1;
      margin: 17px 0 0;
      width: auto;
      height: auto;
    }
    50% {
      opacity: 0.5;
      margin: 17px 0 0;
      width: auto;
      height: auto;
    }
    100% {
      display: none;
      height: 0;
      margin: 0;
      opacity: 0;
      width: 0;
    }
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 25px 0 0;
`;

export const LoadMoreButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  height: 32px;
  min-width: 120px;
  padding: 0 12px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 48px;
    width: 224px;
  }
`;

export const SubList = styled.div`
  animation-duration: 400ms;
  animation-fill-mode: forwards;
  animation-name: ${props => (props.isRemoved ? "sectionDisappears" : "none")};
  margin-bottom: 24px;

  @keyframes sectionDisappears {
    0% {
      opacity: 1;
      margin-bottom: 24px;
    }
    50% {
      opacity: 0.5;
      margin-bottom: 24px;
    }
    100% {
      display: none;
      height: 0;
      margin: 0;
      opacity: 0;
      width: 0;
    }
  }
`;
